import {StyleSheet, Platform} from 'react-native';
import {mvs} from '../../../util/metrices';
import colors from '../../../util/colors';

const DEVOTION_RADIUS = 20;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  scrollContainer: {
    flexGrow: 1,
    paddingBottom: mvs(30),
  },
  header: {
    backgroundColor: colors.primary,
    paddingTop: mvs(20),
    paddingBottom: mvs(30),
    paddingHorizontal: mvs(20),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
    ...(Platform.OS === 'web' ? {
      borderRadius: DEVOTION_RADIUS,
      marginTop: 24,
      marginBottom: 0,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    } : {}),
  },
  headerLeft: {
    alignItems: 'flex-start',
  },
  headerCenter: {
    flex: 1,
    alignItems: 'center',
  },
  headerRight: {
    alignItems: 'flex-end',
  },
  userButton: {
    padding: mvs(8),
    width: mvs(44),
    height: mvs(44),
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateText: {
    fontSize: Platform.OS === 'web' ? 20 : mvs(16),
    color: colors.accent,
    marginBottom: mvs(5),
    fontWeight: Platform.OS === 'web' ? '600' : 'normal',
    letterSpacing: Platform.OS === 'web' ? 0.2 : 0,
  },
  headerTitle: {
    fontSize: Platform.OS === 'web' ? 32 : mvs(28),
    color: colors.textLight,
    fontWeight: Platform.OS === 'web' ? '700' : 'normal',
    letterSpacing: Platform.OS === 'web' ? 0.5 : 0,
    lineHeight: Platform.OS === 'web' ? 40 : undefined,
    marginBottom: Platform.OS === 'web' ? 8 : 0,
  },
  calendarButton: {
    padding: mvs(8),
    width: mvs(44),
    height: mvs(44),
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  // Devotion Card with Background Image
  devotionCardContainer: {
    marginHorizontal: mvs(20),
    marginTop: mvs(30),
    borderRadius: mvs(20),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 0.25,
    shadowRadius: 15,
    elevation: 10,
  },
  devotionBackgroundGradient: {
    width: '100%',
    position: 'relative',
  },
  darkOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  cornerDecoration: {
    position: 'absolute',
    top: mvs(20),
    left: mvs(20),
    opacity: 0.3,
  },
  cornerDecoration2: {
    position: 'absolute',
    bottom: mvs(20),
    right: mvs(20),
    opacity: 0.3,
  },
  cornerText: {
    fontSize: mvs(24),
    color: '#FFFFFF',
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  devotionContent: {
    padding: mvs(30),
    width: '100%',
  },
  devotionCardTitle: {
    fontSize: mvs(28),
    color: '#FFFFFF',
    textAlign: 'center',
    marginBottom: mvs(20),
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 4,
    fontWeight: 'bold',
  },
  devotionCardText: {
    fontSize: mvs(18),
    color: '#FFFFFF',
    lineHeight: mvs(28),
    textAlign: 'justify',
    textShadowColor: 'rgba(0, 0, 0, 0.7)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 3,
    fontWeight: '500',
    marginBottom: mvs(20),
  },
  devotionFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: mvs(20),
  },
  devotionDate: {
    fontSize: mvs(14),
    color: '#FFFFFF',
    textShadowColor: 'rgba(0, 0, 0, 0.8)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    fontWeight: '600',
  },
  devotionNumber: {
    backgroundColor: colors.antiqueWhite,
    paddingHorizontal: mvs(12),
    paddingVertical: mvs(6),
    borderRadius: mvs(15),
  },
  devotionNumberText: {
    fontSize: mvs(12),
    color: colors.kobicha,
    fontWeight: 'bold',
  },

  buttonContainer: {
    paddingHorizontal: mvs(20),
    paddingTop: mvs(30),
    gap: mvs(20),
  },
  previousDevotionsButton: {
    borderRadius: mvs(16),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.4,
    shadowRadius: 12,
    elevation: 8,
  },
  previousDevotionsButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(18),
    paddingHorizontal: mvs(24),
    gap: mvs(12),
  },
  previousDevotionsButtonText: {
    fontSize: mvs(17),
    color: '#FFFFFF',
    fontWeight: '700',
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  primaryButton: {
    backgroundColor: colors.primary,
    paddingVertical: mvs(16),
    paddingHorizontal: mvs(32),
    borderRadius: mvs(12),
    alignItems: 'center',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  primaryButtonText: {
    fontSize: mvs(16),
    color: colors.textLight,
    fontWeight: '600',
  },
  actionButtonsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: mvs(15),
  },
  shareButton: {
    flex: 1,
    borderRadius: mvs(14),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  shareButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(16),
    paddingHorizontal: mvs(20),
    gap: mvs(10),
  },
  shareButtonText: {
    fontSize: mvs(16),
    color: colors.kobicha,
    fontWeight: '700',
  },
  downloadButton: {
    flex: 1,
    borderRadius: mvs(14),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  downloadButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(16),
    paddingHorizontal: mvs(20),
    gap: mvs(10),
  },
  downloadButtonText: {
    fontSize: mvs(16),
    color: colors.kobicha,
    fontWeight: '700',
  },
  actionButton: {
    flex: 1,
    backgroundColor: colors.antiqueWhite,
    paddingVertical: mvs(16),
    paddingHorizontal: mvs(20),
    borderRadius: mvs(12),
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: mvs(8),
    borderWidth: 1,
    borderColor: colors.ecru,
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  actionButtonText: {
    fontSize: mvs(16),
    color: colors.kobicha,
    fontWeight: '500',
  },
  actionButtonDisabled: {
    backgroundColor: colors.background,
    borderColor: colors.lion,
    opacity: 0.6,
  },
  actionButtonTextDisabled: {
    color: colors.lion,
  },
  
  // Loading state styles
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.background,
    gap: mvs(16),
  },
  loadingText: {
    fontSize: mvs(16),
    color: colors.text,
    textAlign: 'center',
    marginTop: mvs(8),
  },
  
  // New floating share button styles
  floatingShareButton: {
    position: 'absolute',
    bottom: mvs(16),
    right: mvs(16),
    borderRadius: mvs(25),
    overflow: 'hidden',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.4,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 10,
  },
  floatingShareGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(12),
    paddingHorizontal: mvs(20),
    gap: mvs(8),
  },
  floatingShareText: {
    fontSize: mvs(14),
    color: '#FFFFFF',
    fontWeight: '700',
    textShadowColor: 'rgba(0,0,0,0.3)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  
  // Author button styles
  authorButton: {
    borderRadius: mvs(16),
    overflow: 'hidden',
    shadowColor: colors.glassShadow,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
  authorButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: mvs(18),
    paddingHorizontal: mvs(24),
    gap: mvs(12),
  },
  authorButtonText: {
    fontSize: mvs(16),
    color: '#FFFFFF',
    fontWeight: '700',
    flex: 1,
    textAlign: 'center',
  },
});

export default styles;